import React, { useEffect, useMemo } from "react";
import OrderItemCard from "./OrderItemCard";
import { useAppDispatch, useAppSelector } from "../../../State/Store";
import { fetchUserOrderHistory } from "../../../State/customer/orderSlice";
import { CircularProgress } from "@mui/material";

const Orders = () => {
    const dispatch = useAppDispatch();
    const { order } = useAppSelector((state) => state);

    useEffect(() => {
        const jwt = localStorage.getItem("jwt") || "";
        if (jwt) {
            dispatch(fetchUserOrderHistory(jwt));
        }
    }, [dispatch]);

    // Sort orders latest first (by id or orderDate)
    const sortedOrders = useMemo(() => {
        if (!order.orders) return [];
        return [...order.orders].sort((a, b) => {
            if (a.id && b.id) return b.id - a.id;
            return new Date(b.orderDate).getTime() - new Date(a.orderDate).getTime();
        });
    }, [order.orders]);

    return (
        <div className="text-sm min-h-screen max-w-4xl mx-auto py-5 px-2">
            <div className="pb-5">
                <h1 className="font-semibold text-xl">All Orders</h1>
                <p className="text-gray-500">Track and manage your order history</p>
            </div>

            {order.loading ? (
                <div className="flex justify-center py-20">
                    <CircularProgress color="secondary" />
                </div>
            ) : sortedOrders.length === 0 ? (
                <div className="text-center py-20 bg-white rounded-md border">
                    <p className="text-gray-500 text-base">No orders found.</p>
                </div>
            ) : (
                <div className="space-y-4">
                    {sortedOrders.map((ord) =>
                        ord.orderItems?.map((item) => (
                            <OrderItemCard key={`${ord.id}-${item.id}`} order={ord} item={item} />
                        ))
                    )}
                </div>
            )}
        </div>
    );
};

export default Orders;